import { render, staticRenderFns } from "./BaseInfoDialog.vue?vue&type=template&id=eb4f4f94&scoped=true&"
import script from "./BaseInfoDialog.vue?vue&type=script&lang=js&"
export * from "./BaseInfoDialog.vue?vue&type=script&lang=js&"
import style0 from "./BaseInfoDialog.vue?vue&type=style&index=0&id=eb4f4f94&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb4f4f94",
  null
  
)

export default component.exports